/** Standard client-directory filters (account, visit, membership). */

export const ACCOUNT_FILTERS = [
    { id: "all", label: "All" },
    { id: "due", label: "Balance due" },
    { id: "pending", label: "Pending" },
    { id: "clear", label: "Clear" },
    { id: "members", label: "Members" },
    { id: "no_visit", label: "No visit yet" },
    { id: "inactive", label: "Inactive 90d+" },
];

export const GENDER_FILTERS = [
    { id: "all", label: "All genders" },
    { id: "female", label: "Female" },
    { id: "male", label: "Male" },
    { id: "other", label: "Other" },
];

export const SORT_OPTIONS = [
    { id: "newest", label: "Newest first" },
    { id: "name", label: "Name A–Z" },
    { id: "last_visit", label: "Recent visit" },
    { id: "due_first", label: "Highest due" },
];

const INACTIVE_DAYS = 90;

export function matchesAccountFilter(customer, filterId) {
    if (!filterId || filterId === "all") return true;
    const acc = customer.account || {};
    const status = acc.status || "clear";
    switch (filterId) {
    case "due":
        return (acc.balance_due || 0) > 0;
    case "pending":
        return status === "pending" || (acc.pending_online_count || 0) > 0;
    case "clear":
        return status === "clear";
    case "members":
        return (acc.active_membership_count || 0) > 0;
    case "no_visit":
        return !customer.last_visit_at;
    case "inactive": {
        if (!customer.last_visit_at) return false;
        const days = (Date.now() - new Date(customer.last_visit_at).getTime()) / 86400000;
        return days >= INACTIVE_DAYS;
    }
    default:
        return true;
    }
}

export function matchesGenderFilter(customer, gender) {
    if (!gender || gender === "all") return true;
    return (customer.gender || "").toLowerCase() === gender;
}

export function applyCustomerFilters(list, { accountFilter, gender }) {
    return list.filter(
        (c) => matchesAccountFilter(c, accountFilter) && matchesGenderFilter(c, gender),
    );
}

export function sortCustomerList(list, sortId) {
    const arr = [...list];
    switch (sortId) {
    case "name":
        return arr.sort((a, b) => (a.full_name || "").localeCompare(b.full_name || "", "en"));
    case "last_visit":
        return arr.sort((a, b) => {
            if (!a.last_visit_at && !b.last_visit_at) return 0;
            if (!a.last_visit_at) return 1;
            if (!b.last_visit_at) return -1;
            return b.last_visit_at.localeCompare(a.last_visit_at);
        });
    case "due_first":
        return arr.sort(
            (a, b) => (b.account?.balance_due || 0) - (a.account?.balance_due || 0),
        );
    case "newest":
    default:
        return arr.sort((a, b) => (b.created_at || "").localeCompare(a.created_at || ""));
    }
}

export function accountFilterCounts(list) {
    const counts = {};
    for (const f of ACCOUNT_FILTERS) {
        counts[f.id] = f.id === "all"
            ? list.length
            : list.filter((c) => matchesAccountFilter(c, f.id)).length;
    }
    return counts;
}

export function hasActiveFilters({ accountFilter, gender }) {
    return (accountFilter && accountFilter !== "all") || (gender && gender !== "all");
}
